import { linkService } from '@/services/api'
import { groupByArrayOfObject } from '@/common/arrays'
import { LinkType } from '@/constants'

const initialStates = {
    status: 'LOADING',
    linksList: {},
    pagination: {
        no_paginate: false,
        per_page: 20,
        current_page: 1,
        last_page: 1,
    },
    params: {
        page: 1
    },
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setLinksList(state, links) {
        state.status = 'SET_LIST'
        state.linksList = links
    },
    setPagination(state, pagination) {
        state.status = 'SET_PAGINATION'
        state.pagination = Object.assign({}, state.pagination, pagination)
    },
    setParams(state, params) {
        state.status = 'SET_PARAMS'
        state.params = Object.assign({}, state.params, params)
    },
    resetParams(state) {
        state.status = 'RESET_PARAMS'
        state.params = {
            page: 1
        }
    },
    createLink(state, link) {
        state.status = 'CREATE'
        state.linksList = Object.assign({ [link.id]: link }, state.linksList)
    },
    updateLink(state, link) {
        state.status = 'UPDATE'
        state.linksList[link.id] = Object.assign({}, state.linksList[link.id], link)
    },
    deleteLink(state, id) {
        state.status = 'DELETE_FROM_LIST'
        delete state.linksList[id]
    },
    error(state) {
        state.status = 'ERROR'
    },
}

const getters = {
    status: ({ status }) => status,
    links: state => state.linksList,
    linkById: state => id => state.linksList[id],
    params: state => state.params,
    pagination: state => state.pagination,
    selectableLinks: (state, getters) => {
        return Object.keys(getters.links).map((id) => {
            return {
                value: id,
                label: getters.links[id].title,
            }
        })
    },
    linkByType: (state, getters) => type => Object.values(getters.links).filter(item => item.type === type)
}

const actions = {
    setParamsAndFetch({ dispatch }, params) {
        dispatch('setParams', params)
        dispatch('fetch')
    },
    setParams({ commit }, params) {
        commit('setParams', params)
    },
    resetParams({ commit }) {
        commit('resetParams')
    },
    fetch({ commit, state }, params) {
        params = Object.assign({}, state.params, params)

        commit('loading')

        return new Promise((resolve, reject) => {
            linkService.fetch(params)
                .then(response => {
                    const result = response.data
                    const links = groupByArrayOfObject(result.data, 'id')

                    commit('setLinksList', links)
                    if (params.no_paginate) {
                        commit('setPagination', {
                            no_paginate: true
                        })
                    } else {
                        commit('setPagination', {
                            per_page: result.per_page,
                            current_page: result.current_page,
                            last_page: result.last_page,
                            no_paginate: false,
                        })
                        commit('setParams', {
                            page: result.current_page,
                        })
                    }
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },

    // We have no find method for links

    create({ commit }, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            linkService.create({
                type: LinkType.EXCLUSIVE,
                ...params,
            })
                .then(response => {
                    const result = response.data

                    commit('createLink', result.data)
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    edit({ commit }, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            linkService.edit(params, params.id)
                .then(() => {
                    commit('updateLink', params)
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    editDisableLinks({ commit }, params) {
        commit('loading')

        return new Promise((resolve, reject) => {
            linkService.editDisableLinks(params)
                .then(() => {
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    delete({ commit }, hashid) {
        commit('loading')

        return new Promise((resolve, reject) => {
            linkService.delete(hashid)
                .then(() => {
                    commit('deleteLink', hashid)
                    resolve()
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}